
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>एक शाम गीतों के नाम - 2025 </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm photo-gallery section-banner-bg-1">
    <div class="container">
      <!-- <form (ngSubmit)="onSubmit()" #registerForm="ngForm">
  <input type="text" name="name" [(ngModel)]="user.name" placeholder="Full Name" required>
  <input type="email" name="email" [(ngModel)]="user.email" placeholder="Email" required>
  <input type="password" name="password" [(ngModel)]="user.password" placeholder="Password" required>
  <button type="submit">Register</button>
</form> -->

        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-1.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-1.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-1.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-2.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-2.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-2.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-3.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-3.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-3.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-4.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-4.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-4.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-5.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-5.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-5.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-7.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-7.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-7.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-6.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-6.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-6.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>


            </ul>
        </div>
    </div>
</section>
